import { View, Text, Link } from '@react-pdf/renderer';
import { onboardingPdfReportStyle } from '@/features/pdf-report/lib/pdf-theme';
import { possessive,
    parseCustomDisclosures,
    getCustomDisclosuresTitle,
    type DisclosureParagraph,
} from '@shared';

interface DisclosuresProps {
    name: string;
    roundStep?: number | null;
    customDisclosuresHtml?: string | null;
    organizationName?: string | null;
}

function renderParagraph(paragraph: DisclosureParagraph, key: string | number) {
    return (
        <Text
            key={key}
            style={onboardingPdfReportStyle.disclosureText}
        >
            {paragraph.map((segment, i) => {
                if (segment.type === 'link') {
                    return (
                        <Link
                            key={i}
                            src={segment.url}
                        >
                            {segment.content}
                        </Link>
                    );
                }
                return <Text key={i}>{segment.content}</Text>;
            })}
        </Text>
    );
}

export function Disclosures({ name, roundStep, customDisclosuresHtml, organizationName }: DisclosuresProps) {
    const word = roundStep === 10 ? 'ten' : roundStep === 100 ? 'hundred' : roundStep === 1000 ? 'thousand' : null;
    const customParagraphs = parseCustomDisclosures(customDisclosuresHtml);
    return (
        <>
            <View style={onboardingPdfReportStyle.disclosureBox} wrap={false}>
                <Text style={onboardingPdfReportStyle.disclosureTitle}>Disclosures</Text>
                <Text style={onboardingPdfReportStyle.disclosureText}>{possessive(name)} projected LTC cost and age they will need LTC are predictions from models trained on other families' LTC journeys. These predictions are estimates and are not guaranteed. {possessive(name)} LTC costs may be higher or lower, and may begin sooner or later than what is shown here. There is no guarantee that a plan built on these numbers will cover {possessive(name)} costs.</Text>
                <Text style={onboardingPdfReportStyle.disclosureText}>The investing and insurance information provided on this page is for educational purposes only. Waterlily Caregiving, Inc. does not offer advisory or brokerage services, nor does it recommend or advise users to buy or sell particular stocks, securities insurance policies, or other financial products. Any information entered about an insurance policy is a subset of policy terms and can only be used to show an estimate of costs covered by a policy. Any policy will likely have terms that limit coverage beyond what is considered here.</Text>
                {word != null && <Text style={onboardingPdfReportStyle.disclosureText}>Where shown, projected long-term care dollar amounts in this report are rounded to the nearest {word} dollars for readability and may not match unrounded model outputs.</Text>}
                <Text style={onboardingPdfReportStyle.disclosureText}>
                    Additional disclaimers and disclosures on our models can be found on our site:{' '}
                    <Link src="https://www.waterlily.com/planning-for-yourself/disclosures-disclaimers">waterlily.com/planning-for-yourself/disclosures-disclaimers</Link>.
                </Text>
            </View>
            {customParagraphs.length > 0 && (
                <View style={onboardingPdfReportStyle.disclosureBox} wrap={false}>
                    <Text style={onboardingPdfReportStyle.disclosureTitle}>{getCustomDisclosuresTitle(organizationName)}</Text>
                    {customParagraphs.map((p, idx) => renderParagraph(p, idx))}
                </View>
            )}
        </>
    );
}
